import axios from "axios";

const backendUrl = (process.env.REACT_APP_BACKEND_URL || "")
  .trim()
  .replace(/\/+$/, "")
  .replace(/\/api$/, "");

// Production is served through the same-origin Nginx /api proxy. Keeping a
// relative fallback prevents CRA from compiling the literal "undefined/api".
export const API = backendUrl ? `${backendUrl}/api` : "/api";

export const ASSETS = {
  characters: "/assets/zeta-guide.webp",
  zetaChar: "/assets/zeta-guide.webp",
  atezChar: "/assets/atez-guide.webp",
  logoWhite: "/assets/zeta-clinic-logo.webp",
  clinic:
    "https://images.unsplash.com/photo-1620283991589-a140ecc4889c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || "905424541225";
export const CONTACT_PHONE = process.env.REACT_APP_CONTACT_PHONE || "+90 542 454 12 25";
export const CONTACT_EMAIL = process.env.REACT_APP_CONTACT_EMAIL || "info@zetaclinic.org";
export const waLink = (text) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text || "Merhaba, Zeta Clinic hakkında bilgi almak istiyorum.")}`;

export const postEvent = (name, meta = {}) => {
  axios.post(`${API}/events`, { name, guide: localStorage.getItem("zeta_guide"), meta }).catch(() => {});
};

export const DOCTORS = [
  {
    id: "d1",
    name: "Dr. Elif Kaya",
    title: { tr: "Protetik Diş Tedavisi Uzmanı", en: "Prosthodontics Specialist" },
    diploma: "Dip. No: 12345 · İstanbul Üniversitesi, 2011",
    years: 13,
    langs: ["TR", "EN", "DE"],
    focus: {
      tr: "Dijital gülüş tasarımı, zirkonyum restorasyonlar",
      en: "Digital smile design, zirconium restorations",
    },
  },
  {
    id: "d2",
    name: "Dr. Mert Aydın",
    title: { tr: "Diş Hekimi — Dijital Gülüş Tasarımı", en: "Dentist — Digital Smile Design" },
    diploma: "Dip. No: 23456 · Hacettepe Üniversitesi, 2014",
    years: 10,
    langs: ["TR", "EN"],
    focus: {
      tr: "CAD/CAM uygulamaları, estetik diş hekimliği",
      en: "CAD/CAM workflows, aesthetic dentistry",
    },
  },
  {
    id: "d3",
    name: "Dr. Selin Demir",
    title: { tr: "Restoratif Diş Tedavisi Uzmanı", en: "Restorative Dentistry Specialist" },
    diploma: "Dip. No: 34567 · Ege Üniversitesi, 2013",
    years: 11,
    langs: ["TR", "EN", "RU"],
    focus: {
      tr: "Minimal invaziv restorasyonlar, renk uyumu",
      en: "Minimally invasive restorations, shade matching",
    },
  },
];

export const FAQS = [
  {
    q: { tr: "Zirkonyum tedavisi için İstanbul'da kaç gün kalmalıyım?", en: "How many days should I stay in Istanbul for zirconium treatment?" },
    a: {
      tr: "Çoğu vakada 5-7 gün yeterlidir. İlk gün muayene ve dijital tarama, ardından laboratuvar süreci ve provalar, son gün yerleştirme yapılır. Kesin süre hekim değerlendirmesiyle netleşir.",
      en: "In most cases 5-7 days is sufficient. Day one covers examination and digital scanning, followed by lab work and try-ins, with placement on the final day. The exact duration is confirmed after the dentist's evaluation.",
    },
  },
  {
    q: { tr: "Tedavi ağrılı mıdır?", en: "Is the treatment painful?" },
    a: {
      tr: "İşlemler lokal anestezi altında yapılır. Hastalarımızın çoğu süreci konforlu olarak tanımlar; hassasiyet olursa hekiminiz yönetim planı sunar.",
      en: "Procedures are performed under local anaesthesia. Most patients describe the process as comfortable; if sensitivity occurs, your dentist provides a management plan.",
    },
  },
  {
    q: { tr: "Garanti kapsamı nedir?", en: "What does the warranty cover?" },
    a: {
      tr: "Kullanılan materyaller için üretici kaynaklı materyal garantisi sunulur. Bu, tedavi sonucu garantisi değildir; nihai sonuç kişisel klinik koşullara bağlıdır ve hekim tarafından değerlendirilir.",
      en: "A manufacturer-backed material warranty applies to the materials used. This is not a treatment outcome guarantee; the final result depends on individual clinical conditions and is assessed by the dentist.",
    },
  },
  {
    q: { tr: "Hangi dillerde destek alabilirim?", en: "Which languages are supported?" },
    a: {
      tr: "Türkçe, İngilizce, Almanca, Arapça ve Rusça tercüme desteği sağlıyoruz. Koordinatörünüz tüm süreç boyunca sizinle kendi dilinizde iletişim kurar.",
      en: "We provide interpretation support in Turkish, English, German, Arabic and Russian. Your coordinator communicates with you in your own language throughout.",
    },
  },
  {
    q: { tr: "Konaklama ve transfer dahil mi?", en: "Are accommodation and transfers included?" },
    a: {
      tr: "Uluslararası hasta paketlerimiz havaalanı karşılama, klinik transferleri ve anlaşmalı otel konaklaması seçeneklerini içerir. Detaylar kişiye özel teklifte netleştirilir.",
      en: "Our international patient packages include airport pickup, clinic transfers and partner hotel accommodation options. Details are confirmed in your personalised offer.",
    },
  },
  {
    q: { tr: "Neden web sitesinde fiyat yok?", en: "Why are there no prices on the website?" },
    a: {
      tr: "Sağlık hizmetlerinde fiyat üzerinden tanıtım mevzuata uygun değildir ve her tedavi planı kişiseldir. Fotoğraflarınızı ilettikten sonra hekim değerlendirmesine dayalı kişiye özel teklif alırsınız.",
      en: "Advertising healthcare by price is not compliant with regulations, and every treatment plan is personal. After you share your photos, you receive a personalised offer based on the dentist's evaluation.",
    },
  },
  {
    q: { tr: "Tedavi sonrası takip nasıl işliyor?", en: "How does aftercare work?" },
    a: {
      tr: "Ülkenize döndükten sonra koordinatörünüz planlı aralıklarla sizinle iletişimde kalır. Sorularınız için WhatsApp ve görüntülü görüşme kanalları açıktır.",
      en: "After you return home, your coordinator stays in touch at planned intervals. WhatsApp and video call channels remain open for your questions.",
    },
  },
  {
    q: { tr: "Herkes zirkonyum tedavisi için uygun mudur?", en: "Is everyone suitable for zirconium treatment?" },
    a: {
      tr: "Hayır. Aktif diş eti hastalığı, yetersiz diş dokusu veya bazı kapanış sorunları olan hastalarda önce farklı tedaviler gerekebilir. Uygunluk her zaman hekim muayenesiyle belirlenir.",
      en: "No. Patients with active gum disease, insufficient tooth structure or certain bite issues may need other treatments first. Suitability is always determined by clinical examination.",
    },
  },
];

export const TESTIMONIALS = [
  {
    name: "M.K.",
    place: { tr: "Berlin, Almanya", en: "Berlin, Germany" },
    text: {
      tr: "Süreç baştan sona planlıydı. Havaalanından alındım, her adımda Almanca destek aldım. Provalarda dişlerin formu üzerine birlikte karar verdik.",
      en: "The process was planned end to end. I was picked up from the airport and had German-language support at every step. We decided on the tooth form together during try-ins.",
    },
  },
  {
    name: "S.A.",
    place: { tr: "Stokholm, İsveç", en: "Stockholm, Sweden" },
    text: {
      tr: "Beni en çok rahatlatan, kimsenin bana abartılı vaatte bulunmamasıydı. Hekim neyin mümkün olup olmadığını açıkça anlattı.",
      en: "What reassured me most was that nobody made exaggerated promises. The dentist explained clearly what was and wasn't possible.",
    },
  },
  {
    name: "R.H.",
    place: { tr: "Riyad, Suudi Arabistan", en: "Riyadh, Saudi Arabia" },
    text: {
      tr: "Dijital tasarımı yerleştirmeden önce ekranda gördüm. Doğal görünüm istedim; sonuç aşırı beyaz değil, bana ait bir gülüş oldu.",
      en: "I saw the digital design on screen before placement. I wanted a natural look; the result is not overly white — it is a smile that belongs to me.",
    },
  },
];
